import {
  openMobileNavigation,
  openMobileAccordions
} from "./init";

import { toggleFooterDropdown } from "./footer";

openMobileNavigation();
openMobileAccordions();
toggleFooterDropdown();
